var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddHomeWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6091_13704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0917969,
    width: 34.8164,
    height: 34.8164,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6091_13704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54272 27.5635V13.0566L11.6975 5.80322L21.8523 13.0566V14.0359C21.2962 14.3018 20.7764 14.6101 20.2928 14.9607C19.8092 15.3112 19.362 15.7041 18.9509 16.1393V14.5073L11.6975 9.3574L4.44409 14.5073V24.6621H7.34546V17.4087H16.0496V24.6621H16.1584C16.2309 25.1698 16.3397 25.6655 16.4848 26.1491C16.6298 26.6326 16.8112 27.1041 17.0288 27.5635H13.1482V20.3101H10.2468V27.5635H1.54272ZM33.4578 1.45117V16.1393C33.0467 15.7041 32.5994 15.3112 32.1159 14.9607C31.6323 14.6101 31.1125 14.3018 30.5564 14.0359V4.35254H17.5002V6.3835L14.5989 4.28V1.45117H33.4578ZM24.7537 10.1553H27.655V7.25391H24.7537V10.1553ZM26.2043 30.4648C24.1976 30.4648 22.487 29.7576 21.0726 28.3432C19.6581 26.9288 18.9509 25.2182 18.9509 23.2114C18.9509 21.2046 19.6581 19.494 21.0726 18.0796C22.487 16.6652 24.1976 15.958 26.2043 15.958C28.2111 15.958 29.9217 16.6652 31.3361 18.0796C32.7506 19.494 33.4578 21.2046 33.4578 23.2114C33.4578 25.2182 32.7506 26.9288 31.3361 28.3432C29.9217 29.7576 28.2111 30.4648 26.2043 30.4648ZM25.479 27.5635H26.9297V23.9368H30.5564V22.4861H26.9297V18.8594H25.479V22.4861H21.8523V23.9368H25.479V27.5635Z",
    fill: "#941B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHomeWork);
export default __webpack_public_path__ + "static/media/addHomeWork.6a4b50885fa92dd6153209088006e589.svg";
export { ForwardRef as ReactComponent };